<template>
    <div class="rubric-section">
        <b-table-simple
            class="apprentice-rubric-table-grid"
            responsive
            bordered>
            <b-thead>
                <b-tr>
                    <b-th>
                        <design-2021-rubric-edit-section-heading-component
                            :section-in="sectionIn"
                            :rubric-show-advanced-options="rubricShowAdvancedOptions"
                            :rubric-sections-in="rubricSectionsIn">
                        </design-2021-rubric-edit-section-heading-component>
                    </b-th>

                    <b-th
                        v-for="column of sectionIn.rubric_columns"
                        :key="`section-${sectionIn.id}-${column.id}`">
                        <design-2021-rubric-edit-column-heading-component
                            :column-in="column"
                            :rubric-show-advanced-options="rubricShowAdvancedOptions"
                            :columnsIn="sectionIn.rubric_columns">
                        </design-2021-rubric-edit-column-heading-component>
                    </b-th>

                    <b-th class="column-add-new-column">
                        <div class="add-new-column">
                            <b-button
                                class="btn-add-circle btn-add-rubric-row"
                                v-b-modal="`create-column-${sectionIn.id}`"
                                variant="outline-primary">
                                <div class="text">
                                    {{ $t('rubrics.add_column') }}
                                </div>
                            </b-button>
                            <design-2021-rubric-edit-create-column-modal-component
                                :section-id="sectionIn.id"
                                :rubric-show-advanced-options="rubricShowAdvancedOptions">
                            </design-2021-rubric-edit-create-column-modal-component>
                        </div>
                    </b-th>
                </b-tr>
            </b-thead>

            <b-tbody>
                <b-tr
                    class="rubric-content-row"
                    v-for="row of sectionIn.rubric_rows"
                    :key="`section-${sectionIn.id}-row-${row.id}`">
                    <b-th sticky-column>
                        <design-2021-rubric-edit-row-heading-component
                            :row-in="row"
                            :rubric-show-advanced-options="rubricShowAdvancedOptions"
                            :rows-in="sectionIn.rubric_rows">
                        </design-2021-rubric-edit-row-heading-component>
                    </b-th>

                    <b-td
                        class="td-rubric-cell"
                        v-for="column of sectionIn.rubric_columns"
                        :key="`section-${sectionIn.id}-row-${row.id}-column-${column.id}`">
                        <design-2021-rubric-edit-column-cell-component
                            :column-in="column"
                            :row-id="row.id"></design-2021-rubric-edit-column-cell-component>
                    </b-td>
                </b-tr>

                <b-tr class="rubric-add-row">
                    <b-td>
                        <div class="add-rubric-row">
                            <b-button
                                class="btn-add-circle btn-add-rubric-row"
                                v-b-modal="`rubric-row-heading-create-row-${sectionIn.id}`"
                                variant="outline-primary">
                                <div class="text">
                                    {{ $t('rubrics.add_row') }}
                                </div>
                            </b-button>
                            <design-2021-rubric-edit-row-heading-create-row-modal-component
                                :section-id="sectionIn.id"
                                :rubric-show-advanced-options="rubricShowAdvancedOptions">
                            </design-2021-rubric-edit-row-heading-create-row-modal-component>
                        </div>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-grid-component',
    props: {
        sectionIn: Object,
        rubricShowAdvancedOptions: Boolean,
        edit: Boolean,
        rubricSectionsIn: Array,
    },
    data() {
        return {
            showOtherResults: !this.edit || !this.$authUser.isStudent(),
        };
    },
    methods: {
        showCreateColumnModal() {
            this.$refs['rubric-create-column'].show(column, false, this.rubric.show_values, section.rubric_columns);
        },

        showCreateRowModal() {
            if (this.sectionIn.rubric_rows.length) {
                const lastIndex = this.sectionIn.rubric_rows.length - 1;
                const row = this.sectionIn.rubric_rows[lastIndex];
                this.$refs['rubric-edit-add-row'].show(row, false, this.rubric.show_values, section.rubric_rows);
            } else {
                const row = {
                    section_id: this.sectionIn.id,
                    order: 0,
                };
                this.$refs['rubric-edit-add-row'].show(row, false, this.rubric.show_values, section.rubric_rows);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.rubric-section {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.apprentice-rubric-table-grid ::v-deep {
    table.table {
        background-color: rgba($secondary-background-color, 0.25);

        thead {
            th {
                vertical-align: top;
                position: static !important;
                background-color: $secondary-background-color;
                border-bottom: 1px solid $border-color;
                max-width: 230px;
            }
        }

        .table-bordered th,
        .table-bordered td {
            border: 1px solid $border-color;
        }

        .td-rubric-cell {
            padding: 0;
        }

        .rubric-content-row {
            height: 1px;
            border-right: 1px solid $border-color;

            td {
                height: inherit;

                .rubric-cell {
                    &,
                    textarea {
                        height: 100%;
                    }
                }
            }
        }

        .column-add-new-column {
            border-right: 1px solid $border-color;
        }

        .rubric-add-row {
            border-bottom: 1px solid $border-color;
            border-top: 1px solid $border-color;
            border-right: 1px solid $border-color;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .apprentice-rubric-table-grid ::v-deep {
        table.table {
            thead {
                th {
                    width: 230px;
                }
            }
        }
    }
}

@-moz-document url-prefix() {
    .apprentice-rubric-table-grid {
        table.table {
            .rubric-content-row {
                height: auto !important;
                > th {
                    background-color: transparent;
                }

                td {
                    height: 100% !important;
                    padding: map-get($grid-gutter-spacing, 'fifteen') !important;
                    background-color: rgba($secondary-background-color, 0.25);

                    .rubric-cell {
                        display: inline-table;
                    }
                }
            }
        }
    }
}
</style>
